import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M1.75 3h20.5s1 0 1 1v16s0 1-1 1H1.75s-1 0-1-1V4s0-1 1-1m14.316 4.934-8.132 8.132m0-8.132 8.132 8.132"
    }, null, -1)
  ]));
}
const interfaceAlertErrorXBlockSquare = { render };
export {
  interfaceAlertErrorXBlockSquare as default,
  render
};
//# sourceMappingURL=interface-alert-error-x-block-square.svg.js.map
